const Meses = [
    {
        "id": 1,
        "mes": "JANEIRO"
    },
    {
        "id": 2,
        "mes": "FEVEREIRO"
    },
    {
        "id": 3,
        "mes": "MARÇO"
    },
    {
        "id": 4,
        "mes": "ABRIL"
    },
    {
        "id": 5,
        "mes": 'MAIO'
    },
    {
        "id": 6,
        "mes": "JUNHO"
    },
    {
        "id": 7,
        "mes": "JULHO"
    },
    {
        "id": 8,
        "mes": "AGOSTO"
    },
    {
        "id": 9,
        "mes": "SETEMBRO"
    },
    {
        "id": 10,
        "mes": "OUTUBRO"
    },
    {
        "id": 11,
        "mes": "NOVEMBRO"
    },
    {
        "id": 12,
        "mes": "DEZEMBRO"
    }
]

export default Meses;